import { createApp } from 'vue'

import App from '@/App.vue'
import '@/styles/theme.css'
import '@/styles/base.css'
import '@/styles/card.css'

createApp(App).mount('#app')
